import { render } from "./dropZone2.vue?vue&type=template&id=650f6e0e&scoped=true"
import script from "./dropZone2.vue?vue&type=script&lang=js"
export * from "./dropZone2.vue?vue&type=script&lang=js"

import "./dropZone2.vue?vue&type=style&index=0&id=650f6e0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650f6e0e"]])

export default __exports__